// Hormuud brand mark: green ring + "H" with a blue Wi‑Fi/SMS signal at top‑right.
// Recreated as inline SVG so it stays crisp at any size and can be tinted via CSS.
export function Logo({ className = "h-8 w-8" }: { className?: string }) {
  return (
    <svg viewBox="0 0 120 120" className={className} role="img" aria-label="Hormuud" xmlns="http://www.w3.org/2000/svg">
      {/* outer ring, broken at the top-right where the signal exits */}
      <g transform="rotate(-18 60 60)">
        <circle
          cx="60"
          cy="60"
          r="50"
          fill="none"
          stroke="#15a44b"
          strokeWidth="13"
          strokeLinecap="round"
          strokeDasharray="262 52"
        />
      </g>
      {/* the H */}
      <g fill="#15a44b">
        <rect x="42" y="38" width="11" height="46" rx="2.5" />
        <rect x="67" y="38" width="11" height="46" rx="2.5" />
        <rect x="42" y="55" width="36" height="11" rx="2" />
      </g>
      {/* Wi‑Fi signal arcs + dot */}
      <g fill="none" stroke="#29abe2" strokeWidth="5" strokeLinecap="round">
        <path d="M84.2 46.5 A13 13 0 0 0 76.5 29.8" />
        <path d="M92.7 49.5 A22 22 0 0 0 79.5 21.3" />
        <path d="M101.1 52.6 A31 31 0 0 0 82.6 12.9" />
      </g>
      <circle cx="72" cy="42" r="6" fill="#29abe2" />
    </svg>
  );
}
